import React, { useEffect, useRef } from 'react'
import './inputs.sass'
import Select from 'react-select'
import UppercaseLabel from '../Typography/UppercaseLabel'

interface SelectOption {
    value: string
    label: string
}

const SingleSelect: React.FC<{
    value?: SelectOption
    options: SelectOption[]
    onValueChange: (selectedOption: SelectOption | null) => void
    placeholder?: string
    inputLabel?: string
    disabled?: boolean
    reset?: boolean
}> = ({ value, options, onValueChange, placeholder, inputLabel, disabled, reset }) => {
    const selectRef = useRef<any>(null)

    useEffect(() => {
        if (reset && selectRef.current) selectRef.current.clearValue()
    }, [reset, selectRef.current])

    return (
        <div>
            {inputLabel && (
                <div className="text-input-wrapper__label-container">
                    <UppercaseLabel>{inputLabel}</UppercaseLabel>
                </div>
            )}
            <Select
                ref={selectRef}
                classNames={{
                    control: () => 'select-input-object',
                }}
                styles={{
                    control: (styles) => ({
                        ...styles,
                        border: '2px solid rgba(17, 17, 17, 0.14)',
                        borderRadius: 4,
                        padding: 1,
                    }),
                }}
                maxMenuHeight={120}
                value={value}
                isDisabled={disabled}
                noOptionsMessage={() => 'Nessuna opzione'}
                options={options}
                isMulti={false}
                onChange={(selectedOption) => onValueChange(selectedOption)}
                placeholder={placeholder || ''}
            />
        </div>
    )
}

export default SingleSelect
